var _rect, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarimg3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 16,
    fill: "url(#paint0_linear_3_5326)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.1395 22.6507C37.0526 22.5631 36.9492 22.4935 36.8352 22.4462C36.7212 22.3989 36.5989 22.3747 36.4755 22.375H35.8125V20.8125C35.8122 20.5639 35.7134 20.3257 35.5376 20.1499C35.3618 19.9741 35.1236 19.8753 34.875 19.875H21.3839C20.6522 19.875 19.9505 20.1657 19.4331 20.6831C18.9157 21.2005 18.625 21.9022 18.625 22.6339V33.3661C18.625 34.0978 18.9157 34.7995 19.4331 35.3169C19.9505 35.8343 20.6522 36.125 21.3839 36.125H36.4386C36.6865 36.1245 36.9242 36.026 37.0999 35.8509C37.2755 35.6759 37.3748 35.4385 37.3761 35.1905L37.4129 23.3157C37.4137 23.1923 37.3899 23.0699 37.343 22.9558C37.2961 22.8416 37.2269 22.7379 37.1395 22.6507ZM36.1271 34.875H21.3839C20.9837 34.875 20.5999 34.716 20.3169 34.4331C20.034 34.1501 19.875 33.7663 19.875 33.3661V22.6339C19.875 22.2337 20.034 21.8499 20.3169 21.5669C20.5999 21.284 20.9837 21.125 21.3839 21.125H34.5625V22.375H21.4375V23.625H36.162L36.1271 34.875Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3125 28.3125H34.5625V29.5625H33.3125V28.3125Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_5326",
    x1: 28,
    y1: 0,
    x2: 28,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarimg3);
export default __webpack_public_path__ + "static/media/sidebar img 3.9d55e67dbc5ee5767d3f8c8867efef31.svg";
export { ForwardRef as ReactComponent };